/** -------------------- 用户角色 -------------------- */
// 1 超级管理员 2 管理员 3 药师 4 渠道管理员 5 药店管理员 6 账号管理员
export enum EUserRoles {
  SUPER_ADMIN = 1,
  ADMIN = 2,
  PHARMACIST = 3,
  CHANNEL_ADMIN = 4,
  DRUGSTORE_ADMIN = 5,
  ACCOUNT_ADMIN = 6,
}
export enum ECAStatus {
  StatusNotStart = 1,
  StatusDoing = 2,
  StatusPassed = 3,
  StatusNotPassed = 4,
}

/** -------------------- 是否加入自动审方签名 -------------------- */
// 1 是 2 否
export enum EUserAutoCheckPerscription {
  YES = 1,
  NO = 0,
}

/** -------------------- 是否启用 -------------------- */
// 0 是 1 否
export enum EUserBlockFlag {
  YES = 0,
  NO = 1,
}

/** -------------------- 账号锁定状态 -------------------- */
// 0 锁定 1 未锁定
export enum EUserLockedState {
  UNLOCKED = 1,
  LOCKED = 2,
}

/** -------------------- 账号归属 -------------------- */
// 1 未设置 2 自营药房 3合作药房
export enum EUserAccountRelegation {
  NONE = 1,
  SELF = 2,
  COOPERATIVE = 3,
}

/** -------------------- 验证码用途 -------------------- */
export enum EUserVerifyCodeUseType {
  REGISTER = 1,
  CHANGE_PHONE = 2,
  BIND_PHONE = 3,
  LOGIN = 4,
  UPDATE_PASSWORD = 5,
}

// 角色名称的字符串表示
export type EUserRoleNames = keyof typeof EUserRoles
